import type { ButtonAttributes, UiButtonEmits, UiButtonIconProps, UiButtonProps } from '~/src/shared/components/ui/button/types/types'
import { computed } from 'vue'

export function useButton(props: UiButtonProps | UiButtonIconProps, emits: UiButtonEmits, attrs: ButtonAttributes) {
    const tag = computed(() => {
        if (props.href) {
            return 'a'
        } else if (props.to) {
            return defineNuxtLink({})
        } else if (props.tag) {
            return props.tag
        } else {
            return 'button'
        }
    })

    const theme = computed(() => props.theme ?? props.color)

    const classes = computed(() => ({
        [`_${theme.value}`]: theme.value,
        [`_icon-${props.iconPosition}`]: props.icon && props.iconPosition,
        _loading: props.loading,
        _disabled: props.disabled,
    }))

    const buttonAttributes = computed<ButtonAttributes>(() => {
        const obj = {
            ...attrs,
        }

        if (props.to) {
            obj.to = props.to
        }

        if (props.href) {
            obj.href = props.href
            obj.target = props.target
        }

        return obj
    })

    function handleClick(event: MouseEvent) {
        if (props.disabled) {
            event.preventDefault()
        }

        emits('click', event)
    }

    function handleMouseEnter(event: MouseEvent) {
        if (props.disabled) {
            return
        }

        emits('mouseenter', event)
    }

    function handleMouseLeave(event: MouseEvent) {
        if (props.disabled) {
            return
        }

        emits('mouseleave', event)
    }

    return {
        tag,
        classes,
        buttonAttributes,
        handleClick,
        handleMouseEnter,
        handleMouseLeave,
    }
}
